module.exports = __webpack_public_path__ + "img/card-small-b7.b8845b90.png";